module.exports = __webpack_public_path__ + "img/05.af4e91b3.jpg";